import { useState } from 'react';
import { createItemPedido } from '../../services/itemPedidoService';
import { IitemPedido } from '../../interfaces/itemPedido';

const useCreateItemPedido = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = async (itemPedido: IitemPedido) => {
    setLoading(true);
    try {
      await createItemPedido(itemPedido);
    } catch (err) {
      setError('Falha ao criar item de pedido');
    } finally {
      setLoading(false);
    }
  };

  return { createItemPedido: create, loading, error };
};

export default useCreateItemPedido;
